import { type LinearConfiguration } from "~/features/configurator/Linear/models";
import { type LinearConfiguratorState } from "~/features/configurator/Linear/redux/types";
import { type CsticUpdate } from "~/features/configurator/Linear/api/sendLinearConfiguratorUpdate";
import { sendCarriage } from "~/features/configurator/Carriage/api/sendCarriageCommon";
import { getMainKmat } from "~/features/configurator/Shaft/common/commonShaftHelpers";
import { FAKE_CSTIC_LUBRICATION_CONNECTOR_TYPE } from "~/features/configurator/Carriage/carriageConfiguratorConstants";
import { ConfiguratorType } from "~/domains/configurator/types/ConfiguratorType";
import { transform } from "~/features/configurator/Linear/linearDataTransformer";
import { isNonNull } from "~/common/utils/reducers";
import { buildConfiguratorMutationCommand } from "~/features/configurator/common/api/configuratorCommands";

export async function sendCarriageUpdate(
  linearState: LinearConfiguratorState,
  updatedCstics: CsticUpdate[],
): Promise<LinearConfiguration | null> {
  const result = buildConfiguratorMutationCommand(linearState, updatedCstics);
  if (result.kind === "local-only") {
    return null;
  }

  const response = await sendCarriage(result.command);

  const oldCstics = getMainKmat({ kmats: linearState.kmats }).cstics;
  const csticsToPreserve = [FAKE_CSTIC_LUBRICATION_CONNECTOR_TYPE].map((name) => oldCstics[name]).filter(isNonNull);

  return transform(response, ConfiguratorType.Carriage, csticsToPreserve);
}
